module.exports = __webpack_public_path__ + "fonts/UTMGodsWordR.11f175b.ttf";